import React from 'react';

const labels = /^(Q|A|Objection|Acknowledge|Clarifying question|Response|Optional next step):\s*/;

export const BusinessKnowledgeContent = ({ content, references = [], isDark }) => {
  const text = isDark ? 'text-gray-200' : 'text-gray-700';
  const heading = isDark ? 'text-white' : 'text-gray-900';
  const blocks = (content || '').split(/\n\s*\n/).filter(Boolean);
  return (
    <article className={`min-w-0 text-sm leading-7 [overflow-wrap:anywhere] ${text}`} data-testid="business-knowledge-content">
      {blocks.map((block, index) => {
        const id = `knowledge-block-${index}`;
        if (block.startsWith('## ')) {
          return <h2 key={id} data-testid={id} className={`text-base md:text-lg font-semibold mt-8 first:mt-0 mb-3 ${heading}`}>{block.slice(3)}</h2>;
        }
        const lines = block.split('\n');
        if (lines.every(line => line.startsWith('- '))) {
          return <ul key={id} data-testid={id} className="list-disc pl-5 mb-5 space-y-1.5">{lines.map((line, i) => <li key={i} data-testid={`${id}-item-${i}`}>{line.slice(2)}</li>)}</ul>;
        }
        return <div key={id} data-testid={id} className="mb-6 space-y-2">
          {lines.map((line, i) => {
            const match = line.match(labels);
            return <p key={i} data-testid={`${id}-line-${i}`} className={match?.[1] === 'Q' || match?.[1] === 'Objection' ? `font-semibold ${heading}` : ''}>
              {match ? <><span className={`font-semibold ${heading}`}>{match[1] === 'Q' ? 'Question' : match[1] === 'A' ? 'Answer' : match[1]}: </span>{line.slice(match[0].length)}</> : line}
            </p>;
          })}
        </div>;
      })}
      {!!references.length && <details className={`mt-8 pt-4 border-t ${isDark ? 'border-white/10' : 'border-gray-200'}`} data-testid="knowledge-sources">
        <summary className="cursor-pointer text-sm font-medium hover:text-teal-500 transition-colors" data-testid="knowledge-sources-toggle">Source references ({references.length})</summary>
        <ul className="mt-3 space-y-2 text-xs" data-testid="knowledge-sources-list">
          {references.map((source, i) => <li key={i} data-testid={`knowledge-source-${i}`}>
            {/^(https?:\/\/)/i.test(source.url || '') ? <a href={source.url} target="_blank" rel="noreferrer" className="underline underline-offset-4 hover:text-teal-500 transition-colors" data-testid={`knowledge-source-link-${i}`}>{source.url}</a> : source.name || 'Supplied document'}
            {source.truncated && <span data-testid={`knowledge-source-limit-${i}`}> · Partial capture</span>}
          </li>)}
        </ul>
      </details>}
    </article>
  );
};